<div *ngIf="showComponent" class="vertical-divider m-l-10 m-r-10"></div>
<div *ngIf="showComponent" class="component-container">
  <div class="offer-number">
    <span>Nr oferty: </span>
    <span>{{ offerNumber }}</span>
  </div>
</div>
